import {inIframe} from "../inIframe";

export class Translator {
    private language: "da" | "de" | "en" = "en";

    private danishTranslations: any = {
        'START_TEXT': 'Start',
        'END_TEXT': 'Slut',
        'AVAILABLE_TEXT': 'Pladser i alt',
        'FREE_TEXT': 'Ledige pladser',
        'PRICE_PER_SEAT': 'Pris pr. plads',
        'DESCRIPTION_TEXT': 'Beskrivelse',
        'SIGNUP_TEXT': 'Online Booking',
        'SIGNUP_TEXT_IFRAME': 'Online Booking (Nyt vindue)',
        'LAST_NAME_TEXT': 'Dit efternavn',
        'FIRST_NAME_TEXT': 'Dit fornavn',
        'NAME_TEXT': 'Dit navn',
        'PHONE_NUMBER_TEXT': 'Dit mobilnummer',
        'PERSON_AMOUNT_TEXT': 'Antal personer',
        'BACK_BTN': 'Tilbage',
        'CONTINUE_BTN': 'Videre',
        'EMAIL_TEXT': 'Din email',
        'ADDRESS_TEXT': 'Din adresse',
        'CONTACT_PERSON_ADDRESS_TEXT': 'Turlederens adresse',
        'NOTE_TEXT': 'Bemærkninger',
        'CONFIRM_TEXT': 'Bekræft dine oplysninger',
        'CONFIRM_BTN': 'Bekræft og tilmeld',
        'CONFIRM_AND_PAY_BTN': 'Bekræft og betal',
        'CONGRATS_TEXT': 'Tillykke! Du er nu tilmeldt, og kan lukke dette vindue!',
        'CONGRATS_TEXT_SINGLE_BOOKING': 'Tillykke! Du er nu tilmeldt begivenheden! Du vil straks modtage en bekræftelse pr. mail.',
        'NEWS_CHECKBOX': ' Jeg ønsker at modtage nyheder pr. SMS eller email',
        'TERMS_CHECKBOX': ' Jeg accepterer',
        'TERMS_LINKTEXT': 'handelsbetingelserne',
        'CANCELLED_TEXT': 'Aflyst',
        'OCCUPIED_TEXT': 'Alt optaget',
        'OCCUPIED_BY_BUSINESS_TEXT': 'Alt optaget',
        'CLOSE_TEXT': 'Luk',
        'PARTY_LAST_NAME_TEXT': 'Efternavn',
        'PARTY_FIRST_NAME_TEXT': 'Fornavn',
        'PARTY_PHONE_NUMBER_TEXT': 'Mobilnummer',
        'PARTY_EMAIL_TEXT': 'Email',
        'PARTY_INFO_TEXT': 'Indtast venligst informationer om alle personer tilknyttet denne booking. Vi bruger det til at kontakte dem i tilfælde af aflysninger mm.',
        "TERMS_LINK": "https://www.ivanslystfiskeri.dk/om-os/forretningsbetingelser.aspx",
        "UNIQUE_PHONE_NUMBER": "Telefonnumrene skal være unikke.",
        "MANAGER_LABEL": "Vælg en turleder*",
        "PAID_EQUIPMENT_TEXT": "Dine tilvalg kan ses herunder:",
        "PAYMENT_LABEL_TITLE": "Note til betaling:",
        "PAYMENT_LABEL_SINGLE_DAY_TRIP": "Ved éndagsture hæves beløbet først når turen starter, men kan være reserveret indtil da.",
        "PAYMENT_LABEL_MULTI_DAY_TRIP": "Ved flerdagsture hæves straks et depositum på 15%. De resterende 85% hæves når turen starter.",
    };

    private englishTranslations: any = {
        'START_TEXT': 'Start',
        'END_TEXT': 'End',
        'AVAILABLE_TEXT': 'Total',
        'FREE_TEXT': 'Available',
        'PRICE_PER_SEAT': 'Price pr. seat',
        'DESCRIPTION_TEXT': 'Description',
        'SIGNUP_TEXT': 'Online Booking',
        'SIGNUP_TEXT_IFRAME': 'Online Booking (New window)',
        'LAST_NAME_TEXT': 'Your last name',
        'FIRST_NAME_TEXT': 'Your first name',
        'NAME_TEXT': 'Your name',
        'PHONE_NUMBER_TEXT': 'Your mobile phone number',
        'PERSON_AMOUNT_TEXT': 'Number of persons',
        'BACK_BTN': 'Back',
        'CONTINUE_BTN': 'Continue',
        'EMAIL_TEXT': 'Your email address',
        'ADDRESS_TEXT': 'Your address',
        'CONTACT_PERSON_ADDRESS_TEXT': 'The address for the contact person',
        'NOTE_TEXT': 'Notes',
        'CONFIRM_TEXT': 'Validate your information',
        'CONFIRM_BTN': 'Validate and sign up',
        'CONFIRM_AND_PAY_BTN': 'Confirm and pay',
        'CONGRATS_TEXT': 'Congratulations! You are now signed up and may close this window!',
        'CONGRATS_TEXT_SINGLE_BOOKING': 'Congratulations! You are now signed up and will shortly recieve and confirmation by mail.',
        'NEWS_CHECKBOX': ' I want to receive news by SMS or mail',
        'TERMS_CHECKBOX': ' I agree to the terms & conditions',
        'CANCELLED_TEXT': 'Cancelled',
        'OCCUPIED_TEXT': 'Everything occupied',
        'OCCUPIED_BY_BUSINESS_TEXT': 'Everything occupied',
        'CLOSE_TEXT': 'Close',
        'PARTY_LAST_NAME_TEXT': 'Last Name',
        'PARTY_FIRST_NAME_TEXT': 'First Name',
        'PARTY_PHONE_NUMBER_TEXT': 'Phone Number',
        'PARTY_EMAIL_TEXT': 'Email Address',
        'PARTY_INFO_TEXT': 'Please enter all information regarding your party. We will try to contact all persons in case of e.g. a cancellation.',
        "TERMS_LINK": "",
        "UNIQUE_PHONE_NUMBER": "The phone numbers should be unique.",
        "MANAGER_LABEL": "Please select a tour guide below*",
        "PAID_EQUIPMENT_TEXT": "Your options can be seen below:",
        "PAYMENT_LABEL_TITLE": "Note:",
        "PAYMENT_LABEL_SINGLE_DAY_TRIP": "For one-day trips, the amount is only withdrawn when the trip starts, but can be reserved until then.",
        "PAYMENT_LABEL_MULTI_DAY_TRIP": "For multi-day trips, a deposit of 15% is withdrawn immediately. The remaining 85% is withdrawn when the trip starts.",
    }

    private germanTranslations: any = {
        'START_TEXT': 'Start',
        'END_TEXT': 'Ende',
        'AVAILABLE_TEXT': 'Plätze gesamt',
        'FREE_TEXT': 'Freie Plätze',
        'PRICE_PER_SEAT': 'Preis pro platz',
        'DESCRIPTION_TEXT': 'Beschreibung ',
        'SIGNUP_TEXT': 'Online Buchung (neues Fenster)',
        'SIGNUP_TEXT_IFRAME': 'Online Buchung (neues Fenster)',
        'LAST_NAME_TEXT': 'Ihr Nachname',
        'FIRST_NAME_TEXT': 'Ihre Vorname',
        'NAME_TEXT': 'Ihr Name',
        'PHONE_NUMBER_TEXT': 'Handynummer',
        'PERSON_AMOUNT_TEXT': 'Anzahl Personen',
        'BACK_BTN': 'Zurück',
        'CONTINUE_BTN': "Weiter",
        'EMAIL_TEXT': 'E-Mailadresse',
        'ADDRESS_TEXT': 'Anschrift',
        'CONTACT_PERSON_ADDRESS_TEXT': 'Die Adresse des Reiseleiters',
        'NOTE_TEXT': 'Anmerkungen',
        'CONFIRM_TEXT': 'Bestätigen Sie Ihre Angaben',
        'CONFIRM_BTN': 'Bestätigen und Anmelden',
        'CONFIRM_AND_PAY_BTN': 'Bestätigen und zahlen',
        'CONGRATS_TEXT': 'Herzlichen Glückwunsch! Sie sind jetzt angemeldet und können das Fenster schließen!',
        'CONGRATS_TEXT_SINGLE_BOOKING': 'Herzlichen Glückwunsch! Sie sind nun auf das Ereignis abonnieren! Sie erhalten umgehend eine Bestätigungsmail erhalten.',
        'NEWS_CHECKBOX': 'Ich möchte Neuigkeiten zu erhalten',
        'TERMS_CHECKBOX': 'Ich akzeptiere',
        'TERMS_LINKTEXT': 'die allgemeinen Geschäftsbedingungen',
        'CANCELLED_TEXT': 'Annulliert',
        'OCCUPIED_TEXT': 'Keine freien Plätze',
        'OCCUPIED_BY_BUSINESS_TEXT': 'Keine freien Plätze',
        'CLOSE_TEXT': 'Geschlossen',
        'PARTY_LAST_NAME_TEXT': 'Nachname',
        'PARTY_FIRST_NAME_TEXT': 'Vorname',
        'PARTY_PHONE_NUMBER_TEXT': 'Handynummer',
        'PARTY_EMAIL_TEXT': 'E-Mail',
        'PARTY_INFO_TEXT': 'Bitte nennen Sie uns die Kontaktdaten aller Mitreisender. Wir werden versuchen, alle registrierten Personen im Falle einer wetterbedingten Absage zu informieren.',
        "TERMS_LINK": "https://www.ivanslystfiskeri.dk/de/profil/geschaftsbedingungen.aspx",
        "UNIQUE_PHONE_NUMBER": "Die Telefonnummern sollten eindeutig sein.",
        "MANAGER_LABEL": "Wählen Sie einen Reiseleiter*",
        "PAID_EQUIPMENT_TEXT": "Ihre Optionen sind unten zu sehen:",
        "PAYMENT_LABEL": "Hinweis: Bei Tagesfahrten wird jetzt der volle Betrag bezahlt. Bei mehrtägigen Reisen wird eine Anzahlung von 15 % im Voraus bezahlt und der Rest automatisch ein paar Tage vor Reisebeginn verrechnet.",
        "PAYMENT_LABEL_TITLE": "Hinweis zur Zahlung:",
        "PAYMENT_LABEL_SINGLE_DAY_TRIP": "Bei Tagesfahrten wird der Betrag erst bei Fahrtantritt abgebucht, kann aber bis dahin reserviert werden.",
        "PAYMENT_LABEL_MULTI_DAY_TRIP": "Bei mehrtägigen Reisen wird eine Anzahlung von 15 % sofort abgebucht. Die restlichen 85 % werden bei Reiseantritt abgebucht.",
    }

    constructor(language: "da" | "de" | "en" = "en") {
        this.language = language;

        this.setText("totalSeats", "AVAILABLE_TEXT");
        this.setText("freeText", "FREE_TEXT");

        this.setText("pricePerSeat", "PRICE_PER_SEAT");

        if(inIframe()) {
            this.setText("signupText", "SIGNUP_TEXT_IFRAME");
        } else {
            this.setText("signupText", "SIGNUP_TEXT");
        }

        this.setText("termsLinkText", "TERMS_LINKTEXT");
        this.setAnchor("termsLink", "TERMS_LINK");

        this.setText("startDateText", "START_TEXT");
        this.setText("endDateText", "END_TEXT");

        this.setText("phoneNumberLabel", "PHONE_NUMBER_TEXT");
        this.setPlaceholder("phone","PHONE_NUMBER_TEXT");

        this.setText("partyFirstNameText","PARTY_FIRST_NAME_TEXT");

        this.setText("firstNameText","FIRST_NAME_TEXT");
        this.setPlaceholder("firstname","FIRST_NAME_TEXT");
        this.setText("lastNameText","LAST_NAME_TEXT");
        this.setPlaceholder("lastname","LAST_NAME_TEXT");
        this.setText("emailLabel","EMAIL_TEXT");
        this.setPlaceholder("email","EMAIL_TEXT");
        this.setText("personAmountLabel","PERSON_AMOUNT_TEXT");
        this.setPlaceholder("amountOfPersons","PERSON_AMOUNT_TEXT");

        this.setText("signUpStepTwoBack","BACK_BTN");
        this.setText("signUpStepTwo","CONTINUE_BTN");
        this.setText("cancelledBtn","CANCELLED_TEXT");
        this.setText("occupiedBtn","OCCUPIED_TEXT");
        this.setText("occupiedBusinessBtn","OCCUPIED_BY_BUSINESS_TEXT");
        this.setText("signUpStepTwoAndAHalf","CONTINUE_BTN");
        this.setText("signUpStepTwoAndAHalfBack","BACK_BTN");

        this.setText("signUpStepThree","CONTINUE_BTN");
        this.setText("signUpStepThreeBack","BACK_BTN");

        this.setPlaceholder("party_firstname","PARTY_FIRST_NAME_TEXT");
        this.setPlaceholder("party_lastname","PARTY_LAST_NAME_TEXT");
        this.setPlaceholder("party_phone","PARTY_PHONE_NUMBER_TEXT");
        this.setPlaceholder("party_email","PARTY_EMAIL_TEXT");

        this.setPlaceholder("address","ADDRESS_TEXT");
        this.setText("addressLabel","ADDRESS_TEXT");

        this.setPlaceholder("noteLabel","NOTE_LABEL");

        this.setText("newsCheckbox","NEWS_CHECKBOX");
        this.setText("termsCheckbox","TERMS_CHECKBOX");

        this.setText("confirmText","CONFIRM_TEXT");
        this.setText("paidEquipmentText", "PAID_EQUIPMENT_TEXT")

        this.setText("signUpStepFour","CONFIRM_BTN");

        this.setText("congrats","CONGRATS_TEXT");
        this.setText("closeBookingModal", "CLOSE_TEXT")
        this.setText("signUpStepFourBack", "BACK_BTN")

        this.setText("personAmountText", "PERSON_AMOUNT_TEXT")
        this.setText("noteText", "NOTE_TEXT")
        this.setText("addressText", "ADDRESS_TEXT")
        this.setText("emailText", "EMAIL_TEXT")
        this.setText("phoneNumberText", "PHONE_NUMBER_TEXT")
        this.setText("nameText", "NAME_TEXT")
        this.setText("startText", "START_TEXT")
        this.setText("endText", "END_TEXT")
        this.setText("partyLastNameText", "PARTY_LAST_NAME_TEXT")
        this.setText("partyPhoneNumberText", "PARTY_PHONE_NUMBER_TEXT")
        this.setText("partyEmailText", "PARTY_EMAIL_TEXT")
        this.setText("partyInfoText", "PARTY_INFO_TEXT")

        this.setText("dialogCloseBtn", "CLOSE_TEXT")

        this.setText("webShopConfirmBtn", "CONTINUE_BTN")

        this.setText("validateStartText", "START_TEXT")
        this.setText("validateEndText", "END_TEXT")

        this.setText("uniquePhoneNumbers", "UNIQUE_PHONE_NUMBER");

        this.setText("managerLabel", "MANAGER_LABEL");

        this.setText("paymentNoteLabel", "PAYMENT_LABEL_TITLE");
        this.setText("paymentNoteSingleDay", "PAYMENT_LABEL_SINGLE_DAY_TRIP")
        this.setText("paymentNoteMultiDay", "PAYMENT_LABEL_MULTI_DAY_TRIP")
    }

    public setText(domId: string, textId: string): void {
        const wrapper = document.getElementById(domId);

        if (wrapper) {
            wrapper.innerText = this.getTranslation(textId);
        } else {
            console.warn("DOM element not found: ", domId);
        }
    }

    private setAnchor(anchorId: string, textId: string): void {
        const wrapper = document.getElementById(anchorId);

        if (wrapper) {
            wrapper.setAttribute("href", this.getTranslation(textId));
        } else {
            console.warn("DOM anchor not found: ", anchorId);
        }
    }

    public setPlaceholder(domId: string, textId: string): void {
        const wrapper = document.getElementById(domId);

        if (wrapper) {
            wrapper.setAttribute("placeholder", this.getTranslation(textId));
        } else {
            console.warn("DOM anchor not found: ", domId);
        }
    }

    public getTranslation(translation: string): string {
        switch (this.language) {
            default:
            case "da":
                return this.danishTranslations[translation];
            case "de":
                return this.germanTranslations[translation];
            case "en":
                return this.englishTranslations[translation];
        }
    }
}
